// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable react/style-prop-object */ /* eslint-disable max-len */
import React from 'react';

const PrivacyPolicyId: React.FC = () => (
  <div className="px-10 py-10">
    <p align="center">
      <br />
      <strong>
        KEBIJAKAN PRIVASI MAB
      </strong>
    </p>
    <br />
    <br />
    <p>
      <strong>1. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gambaran Umum</strong>
    </p>
    <div className="ml-5 flex flex-col gap-3 mt-4">
      <p align="justify">
        i.&nbsp; Kebijakan Privasi MAB ini (&ldquo;
        <strong>Kebijakan Privasi</strong>
        &rdquo;) menjelaskan bagaimana Kami memperoleh, mengumpulkan, mengakses, menyimpan, menggunakan, memproses, &nbsp;memindahkan, mengungkapkan, dan melindungi Informasi Pribadi Anda yang Anda berikan maupun yang teridentifikasi melalui penggunaan Platform dan/atau Layanan Kami.
      </p>

      <p align="justify">
        ii.&nbsp; Kami mengharapkan Anda membaca Kebijakan Privasi ini dengan seksama untuk memastikan pemahaman Anda atas Kebijakan Privasi ini serta membantu Anda dalam mengambil keputusan untuk (a) menggunakan Layanan dan (b) memberikan Informasi Pribadi Anda kepada Kami.
      </p>

      <p align="justify">
        iii.&nbsp; Kebijakan Privasi ini berlaku untuk semua orang dan entitas yang mengakses atau menggunakan Platform dan/atau Layanan Kami. Dengan mengakses Situs Web dan/atau menggunakan Layanan yang tersedia pada Platform, Anda dengan ini menyatakan secara tegas bahwa Anda telah membaca, mengerti, memahami dan menyetujui ketentuan-ketentuan dalam Kebijakan Privasi ini dan secara tegas menyatakan untuk terikat dan tunduk pada Kebijakan Privasi ini. Secara khusus, Anda mengakui dan memberikan persetujuan kepada Kami untuk mengumpulkan, menggunakan, membagikan, mengungkapkan, menyimpan, mengirimkan, dan mengolah Informasi Pribadi Anda sesuai dengan Kebijakan Privasi ini.
      </p>

      <p align="justify">Kebijakan Privasi ini mencakup hal-hal sebagai berikut:</p>
      <ul className="ml-5">
        <li>1.&nbsp; Gambaran umum</li>
        <li>2.&nbsp; Pengumpulan Informasi Pribadi</li>
        <li>3.&nbsp; Penggunaan dan Pengungkapan Informasi Pribadi Yang Kami Kumpulkan</li>
        <li>4.&nbsp; Lembaga Penilai Kredit</li>
        <li>5.&nbsp; Penyimpanan Informasi Pribadi</li>
        <li>6.&nbsp; Tempat Kami Menyimpan Informasi Pribadi Anda</li>
        <li>7.&nbsp; Keamanan Informasi Pribadi Anda</li>
        <li>8.&nbsp; Akses dan Koreksi Informasi Pribadi</li>
        <li>9.&nbsp; Penarikan Persetujuan Anda</li>
        <li>10.&nbsp; Perubahan Terhadap Kebijakan Privasi Kami</li>
        <li>11.&nbsp; Anak di Bawah Umur</li>
        <li>12.&nbsp; Materi Pemasaran</li>
        <li>13.&nbsp; Platform Pihak Ketiga</li>
        <li>14.&nbsp; Penerapan Anti Pencucian Uang dan Pencegahan Pendanaan Terorisme</li>
        <li>15.&nbsp; Pembatasan Tanggung Jawab</li>
        <li>16.&nbsp; Hukum yang Mengatur dan Bahasa</li>
        <li>17.&nbsp; Definisi</li>
        <li>18.&nbsp; Kontak</li>
      </ul>
    </div>
    <br />
    <p>
      <strong>2. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pengumpulan Informasi Pribadi</strong>
    </p>
    <p className="ml-5 mt-4">
      <strong><u>Umum</u></strong>
    </p>
    <div className="ml-7 flex flex-col gap-3 py-3">

      <p align="justify">
        i.&nbsp; Ketika Anda mengakses Platform atau menggunakan Layanan, Kami dapat memproses data teknis seperti alamat protokol internet
        (
        <em>internet protocol address</em>
        ) Anda, halaman web yang pernah Anda kunjungi, browser internet yang Anda gunakan, halaman web yang sebelumnya dan selanjutnya Anda kunjungi dan durasi setiap kunjungan atau sesi yang memungkinkan Kami untuk mengirimkan fungsi-fungsi Platform.
      </p>

      <p align="justify">
        ii.&nbsp; Sebagai tambahan, dalam beberapa hal, browser dan/atau perangkat dapat menyarankan Anda untuk mengaktifkan fungsi
        <em>&nbsp;geo-location&nbsp;</em>
        Anda untuk memungkinkan Kami memberikan Anda suatu pengalaman yang lebih baik dalam menggunakan Layanan. Dengan data teknis ini, Kami dapat mengelola Platform dan Layanan, misalnya dengan menyelesaikan kesulitan-kesulitan teknis atau memperbaiki kemampuan akses bagian-bagian tertentu dari Platform dan Layanan.
      </p>

      <p align="justify">
        iii.&nbsp; Apabila Anda menggunakan Layanan melalui Platform yang disediakan pihak ketiga, penggunaan Platform dan Layanan oleh Anda akan tunduk juga pada kebijakan privasi yang berlaku pada platform pihak ketiga tersebut.
      </p>

      <p align="justify">
        iv.&nbsp; Dari waktu ke waktu, Kami dapat mengumpulkan Informasi Pribadi Anda, termasuk Informasi Pribadi yang:
      </p>
      <div className="ml-5 flex flex-col gap-3">
        <p align="justify">
          (a)&nbsp; diberikan oleh Anda ataupun Pihak yang Disetujui kepada Kami (&ldquo;
          <strong>Informasi Pribadi yang Anda Berikan</strong>
          &rdquo;);
        </p>

        <p align="justify">
          (b)&nbsp; teridentifikasi dan Kami kumpulkan atas penggunaan Layanan dan/atau Platform oleh Anda (&ldquo;
          <strong>Informasi Penggunaan Layanan</strong>
          &rdquo;); dan
        </p>

        <p align="justify">
          (c)&nbsp; Kami peroleh dari sumber-sumber yang tersedia untuk umum termasuk namun tidak terbatas pada lembaga atau biro pemeringkat kredit, maupun agen, vendor, mitra dan pihak lainnya yang memberikan layanan kepada Kami, melakukan tugas atas nama Kami, atau dengan siapa Kami akan melakukan kerja sama. Dalam kasus tersebut, Kami hanya akan mengumpulkan Informasi Pribadi Anda untuk atau sehubungan dengan tujuan yang melibatkan pihak ketiga tersebut atau tujuan kerja sama Kami dengan pihak ketiga tersebut (tergantung pada situasinya).
        </p>
      </div>
    </div>

    <p align="justify" className="ml-5">
      <strong><u>Informasi Pribadi yang Anda Berikan.</u></strong>
    </p>
    <div className="ml-7 flex flex-col gap-3 py-3">
      <p align="justify">
        i.&nbsp; Pada saat Anda mendaftar pada Layanan, Anda akan memberikan Informasi Pribadi tertentu kepada Kami sesuai dengan ketentuan penggunaan yang dipersyaratkan untuk masing-masing Layanan. Informasi Pribadi yang Anda Berikan adalah informasi yang benar, akurat, lengkap, tepat dan tidak menyesatkan.
      </p>

      <p align="justify">
        ii.&nbsp; Ketika Anda menggunakan atau memesan suatu Layanan, Anda dapat memberikan Informasi Pribadi kepada Kami, sebagaimana relevan, seperti jenis Layanan, total biaya transaksi, nomor rekening bank dan/atau uang elektronik, alamat, jumlah pinjaman, nama bank, nama pemegang rekening dan/atau data lainnya sebagai pendukung ekosistem Layanan. Anda wajib untuk selalu memperbaharui dan menginformasikan setiap perubahan dari Informasi Pribadi yang Anda berikan kepada Kami. Kami berhak untuk meminta dokumen-dokumen yang dibutuhkan untuk melakukan verifikasi atas setiap Informasi Pribadi yang Anda berikan.
      </p>

      <p align="justify">
        iii.&nbsp; Melalui Anda, Kami dapat mengumpulkan informasi dan data tentang penerima manfaat, pemegang saham, kuasa, wali amanat, penjamin Anda, penyedia jaminan lainnya, dan individu-individu lain yang relevan untuk menyediakan Layanan (secara kolektif semua yang tersebut di atas yang adalah orang perseorangan, &quot;
        <strong>Individu Yang Relevan</strong>
        &quot;). Dengan memberikan Informasi Pribadi Individu Yang Relevan, Anda menjamin bahwa Anda telah mendapatkan persetujuan terlebih dahulu dari Individu Yang Relevan untuk memberikan datanya kepada Kami.
      </p>

      <p align="justify">
        iv.&nbsp; Sehubungan dengan pemberian Layanan kepada Anda, Kami dapat mengumpulkan informasi dan data berikut:
      </p>
      <div className="ml-5 flex flex-col gap-3">
        <p align="justify">
          (a)&nbsp; setiap Informasi Pribadi Anda dan/atau Individu Yang Relevan tersebut yang dapat mengidentifikasi Anda atau Individu Yang Relevan, termasuk tetapi tidak terbatas pada informasi-informasi yang diperlukan sehubungan dengan pelaksanaan prinsip mengenal pelanggan (
          <em>know your customer</em>
          &nbsp;- KYC) sesuai dengan peraturan perundang-undangan yang berlaku dan kebijakan internal Kami;
        </p>

        <p align="justify">
          (b)&nbsp; setiap Informasi Pribadi Anda dan/atau Individu Yang Relevan yang diberikan kepada Kami selama Anda mengakses atau menggunakan Platform dan/atau Layanan, seperti catatan partisipasi dalam setiap korespondensi interaktif pada Platform dan jawaban Anda atas pertanyaan-pertanyaan yang ditujukan untuk verifikasi keamanan; dan
        </p>

        <p align="justify">
          (c)&nbsp; setiap Informasi Pribadi Anda dan/atau Individu Yang Relevan yang diberikan kepada Kami dan pihak yang terkait dengan Layanan termasuk catatan korespondensi melalui telepon, surat, percakapan
          &nbsp;
          <em>online</em>
          , pesan
          {' '}
          <em>online</em>
          <em>,</em>
          &nbsp;email atau melalui bentuk komunikasi lainnya.
        </p>
      </div>
    </div>
    <p className="ml-5">
      <strong>
        <u>
          Informasi yang dikumpulkan setiap kali anda menggunakan Platform
        </u>
      </strong>
    </p>
    <div className="ml-7 flex flex-col gap-3 py-3">
      <p align="justify">
        i.&nbsp; Informasi Pribadi Anda yang dikumpulkan dalam kaitannya dengan setiap kunjungan Anda ke Platform dan penggunaan Layanan termasuk:
      </p>
      <div className="ml-5 flex flex-col gap-3">
        <p align="justify">
          (a)&nbsp; informasi teknis, termasuk alamat&nbsp;
          <em>Internet Protocol</em>
          (IP) yang digunakan untuk menghubungkan perangkat Anda dengan Internet, informasi
          &nbsp;
          <em>login</em>
          &nbsp;
          Anda, tipe dan versi browser, pengaturan zona waktu, tipe dan versi browser plug-in, sistem operasi dan platform;
        </p>

        <p align="justify">
          (b)&nbsp; informasi kunjungan situs, termasuk semua
          &nbsp;
          <em>Uniform Resources Locators</em>
          &nbsp;
          (URL)
          &nbsp;
          <em>clickstream</em>
          &nbsp;
          ke, melalui dan dari Platform (termasuk tanggal dan waktu), layanan-layanan yang Anda lihat atau cari, waktu respons halaman, kesalahan unduh, lama kunjungan ke laman-laman tertentu, informasi interaksi laman (seperti
          &nbsp;
          <em>scrolling,&nbsp; klik,</em>
              &nbsp;dan
              &nbsp;
          <em>mouse-over</em>
          ) dan metode- metode yang digunakan untuk pindah dari laman tersebut dan nomor telepon apapun yang digunakan untuk menghubungi nomor layanan pelanggan Kami;
        </p>

        <p align="justify">
          (c)&nbsp; informasi dan data dari
          &nbsp;
          <em>cookies</em>
              &nbsp;atau teknologi lainnya yang digunakan pada Platform; dan
        </p>

        <p align="justify">
          (d)&nbsp; Informasi kegiatan dan/atau transaksi yang berkaitan dengan Layanan yang Anda gunakan, termasuk hasil pencarian dan sejarah untuk Layanan dalam Platform, catatan transaksi Layanan, catatan pembayaran pinjaman, jumlah pinjaman, tujuan penggunaan pinjaman dan catatan penyaluran pinjaman Anda.
        </p>
      </div>
      <p align="justify">
        ii.&nbsp; Kami juga akan mengumpulkan setiap Informasi Pribadi Anda yang dikumpulkan oleh Kami ketika Anda berpartisipasi dalam acara yang Kami selenggarakan, seperti pesta, seminar, program kontes atau penghargaan, dalam bentuk apapun termasuk foto, rekaman video dan suara Anda. Data tersebut juga dapat kami gunakan dan/atau cantumkan dalam materi komunikasi, publikasi, iklan dan/atau promosi yang Kami lakukan.
      </p>

      <p align="justify">
        iii.&nbsp; Setiap kali anda menggunakan Platform atau mengunjungi Situs Web kami, kami dapat mengumpulkan data teknis tertentu sehubungan dengan penggunaan anda seperti, alamat protokol internet, informasi halaman web yang sebelumnya atau selanjutnya dilihat, durasi setiap kunjungan/sesi, identitas perangkat internet atau alamat kontrol akses media, dan informasi perangkat lainnya termasuk informasi mengenai produsen, model, dan sistem operasi dari perangkat yang anda gunakan untuk mengakses Platform atau Situs Web kami.
      </p>

      <p align="justify">
        iv.&nbsp; Penggunaan
        &nbsp;
        <em>Cookie</em>
          &nbsp;-
        <em>Cookie</em>
        &nbsp;
        adalah berkas data kecil yang ditempatkan browser Anda pada perangkat internet Anda. Dengan
        &nbsp;
        <em>cookie</em>
        , fitur aplikasi dan/atau situs web yang Anda akses dapat menyimpan informasi atau mengingat tindakan dan preferensi Anda dari waktu ke waktu. Sebagian besar browser dan perangkat internet mendukung
        &nbsp;
        <em>cookie</em>
        ; namun Anda dapat mengatur browser atau perangkat yang Anda gunakan untuk menolak beberapa jenis
        {' '}
        <em>cookie</em>
        &nbsp;
        tertentu atau
        {' '}
        <em>cookie</em>
        &nbsp;
        spesifik. Di samping itu, Anda dapat menghapus
        {' '}
        <em>cookie</em>
        &nbsp;
        kapan saja. Kami menggunakan
        {' '}
        <em>cookie</em>
        &nbsp;
        untuk berbagai tujuan. Kami menggunakannya, misalnya, untuk mengingat preferensi penelusuran laman Anda, membantu Anda untuk menggunakan Layanan atau mengelola Layanan.
      </p>
    </div>
    <br />

    <p>
      <strong>3. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Penggunaan dan Pengungkapan Informasi Pribadi Yang Kami Kumpulkan</strong>
    </p>
    <p className="ml-5 mt-4">
      <strong>
        <u>Penggunaan Informasi Pribadi</u>
      </strong>
    </p>
    <div className="ml-7 flex flex-col gap-3 py-3">
      <p align="justify">
        i.&nbsp; Kami menggunakan alamat surat elektronik
        (
        <em>e-mail</em>
        ), nama, nomor telepon, dan/atau sandi akun Anda untuk tujuan verifikasi kepemilikan Anda atas suatu akun dalam Layanan yang disediakan dalam Platform, untuk berkomunikasi dengan Anda sehubungan dengan penggunaan atau pengelolaan Layanan dan untuk memberikan Anda informasi mengenai Layanan dan Platform.
      </p>

      <p align="justify">
        ii.&nbsp; Kami juga dapat menggunakan nama, alamat surat elektronik
        (
        <em>e-mail</em>
        ) dan nomor telepon Anda untuk mengirimkan pesan, perubahan dan/atau pembaharuan yang bersifat umum atas Layanan dan Platform, penawaran-penawaran khusus atau promosi-promosi, menanggapi pertanyaan dan saran yang diterima dari Anda dan memberikan bantuan sehubungan dengan dan untuk menyelesaikan kesulitan teknis atau masalah operasional dengan Platform atau Layanan.
      </p>

      <p align="justify">
        iii.&nbsp; Kami dapat menggunakan Informasi Pribadi Anda untuk memfasilitasi verifikasi apapun yang menurut pertimbangan Kami diperlukan sehubungan dengan proses mengenal pelanggan
        (
        <em>know your customer</em>
        ).
      </p>

      <p align="justify">
        iv.&nbsp; Kami menggunakan Informasi Pribadi Anda seperti, catatan penggunaan dan pembayaran Layanan dan daftar transaksi atau pengeluaran Anda, yang diberikan oleh Anda dan/atau Pihak yang Disetujui untuk:
      </p>
      <div className="ml-5 flex flex-col gap-3">
        <p align="justify">
          (a)&nbsp; menentukan dan menganalisis permohonan Anda untuk menerima Layanan;
        </p>

        <p align="justify">
          (b)&nbsp; menilai program Layanan apa yang sesuai dengan kebutuhan Anda;
        </p>

        <p align="justify">
          (c)&nbsp; Melakukan penagihan terhadap setiap kewajiban yang Anda miliki kepada Kami atau Afiliasi kami sepanjang diperkenankan berdasarkan hukum yang berlaku;
        </p>

        <p align="justify">
          (d)&nbsp; menilai dan menentukan karakteristik transaksi dan kegiatan Anda dalam menerima Layanan; dan/atau
        </p>

        <p align="justify">
          (e)&nbsp; menggunakannya untuk Tujuan Pengembangan Layanan.
        </p>
      </div>
      <p align="justify">
        v.&nbsp; Anda dengan ini setuju bahwa Informasi Pribadi Anda akan digunakan oleh sistem pemrosesan data Kami untuk memastikan diberikannya fungsi yang terbaik pada Layanan dan/atau Platform.
      </p>
    </div>

    <p className="ml-5 mt-4">
      <strong>
        <u>Pengungkapan Informasi Pribadi Anda</u>
      </strong>
    </p>
    <div className="ml-7 flex flex-col gap-3 py-3">
      <p align="justify">
        i.&nbsp; Anda mengakui, memahami, mengerti dan menyetujui bahwa Kami dapat mengungkapkan atau memberikan Informasi Pribadi Anda dengan Afiliasi Kami atau pihak ketiga untuk tujuan antara lain sebagai berikut serta untuk tujuan lain yang diizinkan oleh peraturan perundang-undangan yang berlaku:
      </p>
      <div className="ml-5 flex flex-col gap-3">
        <p align="justify">
          (a)&nbsp; untuk memberikan Layanan kepada Anda, termasuk untuk memproses pendaftaran Anda sehubungan dengan Layanan dan Platform kami, dan untuk berkomunikasi dengan Anda;
        </p>

        <p align="justify">
          (b)&nbsp; jika disyaratkan atau diotorisasikan oleh peraturan perundang-undangan yang berlaku (termasuk namun tidak terbatas pada menanggapi pertanyaan terkait regulasi, penyelidikan atau pedoman, atau mematuhi persyaratan atau ketentuan pengarsipan dan pelaporan berdasarkan undang-undang), untuk tujuan yang ditentukan dalam peraturan perundang-undangan yang berlaku;
        </p>

        <p align="justify">
          (c)&nbsp; jika diinstruksikan, diminta, disyaratkan atau diperbolehkan oleh pemerintah yang berwenang, untuk tujuan sebagaimana disebutkan dalam kebijakan pemerintah, peraturan atau peraturan perundang-undangan yang berlaku.
        </p>

        <p align="justify">
          (d)&nbsp; jika terdapat proses hukum dalam bentuk apapun antara Anda dengan Kami, atau antara Anda dengan pihak lain, sehubungan dengan, atau terkait dengan Layanan, untuk keperluan proses hukum tersebut;
        </p>

        <p align="justify">
          (e)&nbsp; dalam situasi terkait kepentingan umum, Kami dapat membagikan Informasi Pribadi anda kepada pemerintah yang berwenang dan/atau institusi lainnya yang dapat ditunjuk oleh pemerintah yang berwenang atau memiliki kerja sama dengan kami, untuk tujuan mendukung inisiatif, kebijakan atau program pemerintah, kesehatan publik dan tujuan lainnya sebagaimana dibutuhkan secara wajar;
        </p>

        <p align="justify">
          (f)&nbsp; sehubungan dengan segala proses verifikasi yang menurut Kami perlu sebelum kami mendaftarkan Anda sebagai pengguna Layanan, termasuk proses mengenal pelanggan
          (
          <em>know your customer</em>
          ), melakukan pengecekan latar belakang, melakukan penilaian kredit, penilaian kelayakan;
        </p>

        <p align="justify">
          (g)&nbsp; sehubungan dengan, penggabungan, penjualan aset perusahaan, konsolidasi atau restrukturisasi, pembiayaan atau akuisisi semua atau sebagian dari bisnis Kami oleh atau ke perusahaan lain, untuk keperluan transaksi tersebut (bahkan jika kemudian transaksi tidak dilanjutkan);
        </p>

        <p align="justify">
          (h)&nbsp; kepada pihak ketiga, termasuk agen, vendor, pemasok, kontraktor, mitra, dan pihak lain yang memberikan layanan kepada Kami atau Anda, melakukan tugas atas nama Kami, atau pihak dengan siapa Kami mengadakan kerja sama komersial; dan
        </p>
        <p align="justify">
          (i)&nbsp; dalam hal Kami berbagi Informasi Pribadi dengan Afiliasi, Kami akan melakukannya dengan maksud agar mereka membantu Kami dalam menyediakan Layanan, untuk mengoperasikan bisnis Kami (termasuk, ketika Anda berlangganan milis kami, untuk tujuan pemasaran langsung), atau untuk tujuan pengolahan data atas nama Kami. Semua Afiliasi kami berkomitmen untuk mengolah Informasi Pribadi yang mereka terima dari Kami sesuai dengan Kebijakan Privasi dan peraturan perundang-undangan yang berlaku ini.
        </p>
      </div>

      <p align="justify">
        ii.&nbsp; Anda mengakui, memahami, mengerti dan menyetujui bahwa Kami dapat mempekerjakan atau bekerja sama dengan perusahaan-perusahaan dan orang perorangan pihak ketiga untuk memfasilitasi atau memberikan bantuan untuk dan/atau atas nama Kami dengan tujuan untuk:
      </p>
      <div className="ml-5 flex flex-col gap-3">
        <p align="justify">
          (a)&nbsp; memberikan bantuan konsumen;
        </p>

        <p align="justify">
          (b)&nbsp; memberikan informasi
          <em>&nbsp;geo-location</em>
          ;
        </p>

        <p align="justify">
          (c)&nbsp; melaksanakan kegiatan-kegiatan terkait dengan Layanan dan Platform (termasuk namun tidak terbatas pada layanan pemeliharaan, pengelolaan
          <em>&nbsp;database</em>
          , analisis web dan penyempurnaan fitur-fitur Platform);
        </p>

        <p align="justify">
          (d)&nbsp; membantu Kami dalam menganalisis bagaimana Platform dan Layanan digunakan serta bagaimana pengembangannya;
        </p>

        <p align="justify">
          (e)&nbsp; membantu penasihat profesional dan auditor eksternal Kami, termasuk penasihat hukum, penasihat keuangan, dan konsultan-konsultan dalam melaksanakan tugasnya; dan/atau
        </p>

        <p align="justify">
          (f)&nbsp; kepentingan Tujuan Pengembangan Layanan.
        </p>

        <p align="justify">
          Para pihak ketiga tersebut hanya memiliki akses atas dan/atau memperoleh Informasi Pribadi Anda untuk melakukan tugas-tugas tersebut untuk dan/atau atas nama Kami dan secara kontraktual terikat untuk tidak mengungkapkan atau menggunakan Informasi Pribadi tersebut untuk tujuan lain apapun.
        </p>
      </div>
      <p align="justify">
        iii.&nbsp; Anda mengakui, memahami, mengerti dan menyetujui bahwa Kami dapat mengungkapkan Informasi Pribadi Anda sepanjang diwajibkan secara hukum, atau diperlukan untuk tunduk pada ketentuan peraturan perundang-undangan, institusi pemerintah, atau dalam hal terjadi sengketa, atau segala bentuk proses hukum antara Anda dan Kami, atau antara Anda dan pihak lain sehubungan dengan, atau terkait dengan Layanan, atau dalam keadaan darurat yang berkaitan dengan kesehatan dan/atau keselamatan Anda.
      </p>

      <p align="justify">
        iv.&nbsp; Sehubungan dengan pengungkapan Informasi Pribadi Anda sebagaimana dimaksud pada bagian (iii) di atas, Kami dapat mengungkapkan, menampilkan, mengirimkan, melakukan pengkinian data dan memberikan Informasi Pribadi Anda dan informasi lain yang terkait dengan Anda kepada pihak-pihak lain sehubungan dengan keperluan penyelenggaraan Layanan yang antara lain termasuk:
      </p>
      <div className="ml-5 flex flex-col gap-3">
        <p>
          (a)&nbsp; Direktorat Jendral Kependudukan dan Pencatatan Sipil (&ldquo;
          <strong>Dukcapil</strong>
          &rdquo;), Lembaga Negara yang memiliki pusat data kependudukan, atau pihak penyelenggara lainnya yang memiliki koneksi resmi ke Dukcapil atau Lembaga Negara untuk tujuan verifikasi keabsahan identitas Anda. Pemrosesan dan jangka waktu penyimpanan Informasi Pribadi Anda oleh Dukcapil atau Lembaga Negara terkait akan mengikuti ketentuan internal Dukcapil atau Lembaga Negara tersebut.
        </p>

        <p>
          (b)&nbsp; Pihak penyelenggara tanda tangan digital untuk kebutuhan pembuatan tanda tangan elektronik yang dalam prosesnya dapat meliputi verifikasi keabsahan Anda sebagai penandatangan dan pembuatan akun tanda tangan elektronik pada penyelenggara tanda tangan digital dengan tunduk pada syarat dan ketentuan yang diatur terpisah oleh penyelenggara tanda tangan elektronik terkait.
        </p>

        <p>
          (c)&nbsp; Pihak penyelenggara informasi kredit untuk mendapatkan informasi mengenai status kolektibilitas, riwayat kredit dan informasi keuangan lainnya.
        </p>

        <p>
          (d)&nbsp; Mitra penagihan eksternal yang menjalin kerjasama dengan Kami (apabila ada).
        </p>

        <p>
          (e)&nbsp; Mitra asuransi kredit atau mitra penyelenggara penjaminan untuk kebutuhan mitigasi risiko kredit.
        </p>

        <p>
          (f)&nbsp; (Para) Pemberi Pinjaman untuk keperluan permohonan pendanaan terhadap Pinjaman atau apabila Anda tidak melunasi Pinjaman setelah melewati 90 (sembilan puluh) hari kalender setelah tanggal jatuh tempo, Informasi Pribadi milik Anda dapat disimpan oleh (Para) Pemberi Pinjaman untuk kebutuhan penagihan oleh (Para) Pemberi Pinjaman atau pihak lain yang ditunjuk oleh Pemberi Pinjaman kepada Anda.
        </p>

        <p>
          (g)&nbsp; Otoritas Jasa Keuangan (&ldquo;
          <strong>OJK</strong>
          &rdquo;) untuk keperluan investigasi permasalahan atas penggunaan Layanan oleh Anda, pelaporan kegagalan pembayaran oleh Anda atau untuk hal-hal lain sesuai permintaan OJK secara tertulis kepada Kami. Pemrosesan dan jangka waktu penyimpanan Informasi Pribadi Anda oleh OJK akan tunduk kepada ketentuan dan kebijakan internal OJK.
        </p>

        <p>
          (h)&nbsp; Lembaga Alternatif Penyelesaian Sengketa, jika diperlukan, untuk proses penyelesaian sengketa.
        </p>

        <p>
          (i)&nbsp; Pihak asosiasi yang ditunjuk secara resmi oleh OJK dan mewakili OJK untuk kebutuhan pengumpulan informasi untuk pusat data Layanan Pinjam Meminjam Uang Berbasis Teknologi Informasi. Pemrosesan dan jangka waktu penyimpanan Informasi Pribadi milik Anda oleh asosiasi tersebut &nbsp;akan tunduk sepenuhnya pada ketentuan dan arahan dari OJK.
        </p>

        <p>
          (j)&nbsp; Pusat Pelaporan Analisis Transaksi Keuangan (&ldquo;
          <strong>PPATK</strong>
          &rdquo;), apabila Kami mengidentifikasi adanya transaksi keuangan mencurigakan sebagaimana diatur pada ketentuan perundang-undangan mengenai pencegahan dan pemberantasan tindak pidana pencucian uang dan pendanaan terorisme. Pemrosesan dan jangka waktu penyimpanan Informasi Pribadi Anda akan tunduk pada kebijakan yang ditentukan sepenuhnya oleh PPATK.
        </p>

        <p>
          (k)&nbsp; Otoritas penegak hukum di Republik Indonesia antara lain Kepolisian Negara Republik Indonesia, Komisi Pemberantasan Korupsi (&ldquo;
          <strong>KPK</strong>
          &rdquo;), Pengadilan, dan lain sebagainya (secara keseluruhan disebut &ldquo;
          <strong>Otoritas Penegak Hukum</strong>
          &rdquo;) untuk keperluan apapun terkait penegakan hukum yang diduga melibatkan Anda (antara lain, namun tidak terbatas pada kasus pelanggaran hukum, kejahatan, pencucian uang, pendanaan terorisme, korupsi) yang dalam hal ini wajib diminta secara resmi dan tertulis oleh otoritas yang terkait tersebut. Jangka waktu penyimpanan Informasi Pribadi Anda akan tunduk pada kebijakan yang ditentukan sepenuhnya oleh Otoritas Penegak Hukum tersebut.
        </p>

        <p>
          (l)&nbsp; Direktorat Jenderal Pajak Republik Indonesia (&ldquo;
          <strong>DJP</strong>
          &rdquo;) untuk pemenuhan kewajiban pelaporan informasi bagi Anda sesuai ketentuan regulasi perpajakan yang berlaku antara lain peraturan mengenai pertukaran otomatis informasi perpajakan
          <em>(automatic exchange of information)</em>
          . Pemrosesan dan penyimpanan Informasi Pribadi Anda akan tunduk pada ketentuan dan kebijakan yang ditentukan sepenuhnya oleh DJP.
        </p>
      </div>

      <p align="justify">
        v.&nbsp;
        Data Anonim - Kami dapat membuat, menggunakan, melisensikan atau mengungkapkan Informasi Pribadi, yang tersedia, dengan catatan, (i) bahwa semua hal yang dapat mengidentifikasi telah dihapus sehingga data, baik sendiri atau dikombinasi dengan data lain yang tersedia, tidak dapat dihubungkan dengan atau dikaitkan dengan atau tidak dapat mengidentifikasi suatu individu, dan (ii) data serupa telah digabungkan sehingga data asli membentuk bagian dari kumpulan data yang lebih besar,
        kepada pihak ketiga untuk Tujuan Pengembangan Layanan, pengelolaan
        <em>&nbsp;database</em>
        , analisa atau peningkatan Layanan. Kami juga dapat mengkombinasikan Informasi Pribadi Anda dengan informasi-informasi lain sedemikian rupa sehingga informasi tersebut tidak lagi terasosiasi dengan Anda, kemudian mengungkapkan informasi yang telah dikombinasikan tersebut kepada pihak ketiga, untuk tujuan-tujuan tersebut di atas. Kami tidak menjamin sifat anonim dari informasi yang kami berikan tersebut apabila pihak ketiga tersebut telah memperoleh Informasi Pribadi dari Anda dan dapat mengasosiasikan dan mencocokkan data anonim yang Kami berikan dengan data yang telah dan/atau akan Anda berikan kepada pihak ketiga tersebut.
      </p>
    </div>
    <br />

    <p>
      <strong>4. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lembaga Penilai Kredit</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        i.&nbsp; Kami dapat, dengan sendirinya dan/atau sebagai agen Anda, menyediakan Informasi Pribadi Anda dan Individu Yang Relevan kepada lembaga-lembaga penyedia jasa rujukan informasi kredit dan/atau penilaian kemampuan kredit (&ldquo;
        <strong>Lembaga Penilai Kredit</strong>
        &rdquo;) untuk tujuan memperbarui catatan kredit Anda dalam basis data kredit pelanggan dari Lembaga Penilai Kredit. Dalam hal ini, Informasi Pribadi Anda yang akan diungkapkan adalah yang terkait dengan Layanan yang diadakan atau digunakan oleh Anda dan Individu Yang Relevan tersebut.
      </p>

      <p align="justify">
        ii.&nbsp; Untuk tujuan menentukan risiko kredit Anda dalam menerima Layanan, evaluasi nilai kredit dan/atau pemberian layanan tambahan, Kami dapat mengakses dan memperoleh Informasi Pribadi dan akun atau catatan tentang Anda dan Individu Yang Relevan tersebut (termasuk informasi tentang jumlah perhitungan fasilitas atau pinjaman) dari Lembaga Penilai Kredit.
      </p>
    </div>
    <br />

    <p align="justify">
      <strong>5. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Penyimpanan Informasi Pribadi</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        i.&nbsp; Informasi Pribadi Anda hanya akan disimpan selama diperlukan untuk memenuhi tujuan dari pengumpulannya, atau selama penyimpanan tersebut diperlukan atau diperbolehkan oleh peraturan perundang-undangan yang berlaku. Kami akan berhenti menyimpan Informasi Pribadi, atau menghapus maksud dari dikaitkannya Informasi Pribadi tersebut dengan Anda sebagai individu, segera setelah dianggap bahwa tujuan pengumpulan Informasi Pribadi tersebut tidak lagi dibutuhkan dengan menyimpan Informasi Pribadi dan penyimpanan tidak lagi diperlukan untuk tujuan bisnis atau secara hukum.
      </p>

      <p align="justify">
        ii.&nbsp; Mohon diperhatikan bahwa masih ada kemungkinan bahwa beberapa Informasi Pribadi Anda disimpan oleh pihak lain termasuk oleh penyedia layanan, dengan cara tertentu. Informasi yang disampaikan melalui komunikasi antara pengguna dan penyedia layanan yang dilakukan selain melalui Platform (seperti melalui panggilan telepon, SMS, pesan seluler atau cara komunikasi lainnya) juga dapat disimpan dengan beberapa cara. Kami tidak mengizinkan dan mendorong penyimpanan Informasi Pribadi dengan cara demikian dan kami tidak bertanggung jawab kepada Anda untuk hal tersebut. Kami tidak akan bertanggung jawab atas penyimpanan Informasi Pribadi Anda dalam hal tersebut. Anda setuju untuk mengganti rugi, membela, dan membebaskan Kami, pejabat, direktur, karyawan, agen, mitra, pemasok, kontraktor, dan Afiliasi Kami dari dan terhadap setiap dan segala klaim, kerugian, kewajiban, biaya, kerusakan, dan ongkos (termasuk tetapi tidak terbatas pada biaya hukum dan pengeluaran biaya ganti rugi penuh) yang dihasilkan secara langsung atau tidak langsung dari setiap penyimpanan yang tidak sah atas Informasi Pribadi Anda.
      </p>
    </div>
    <br />

    <p align="justify">
      <strong>6. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tempat Kami Menyimpan Informasi Pribadi Anda</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        i.&nbsp; Informasi Pribadi Anda yang Kami kumpulkan dapat disimpan, ditransfer, atau diolah oleh penyedia layanan pihak ketiga. Kami akan menggunakan semua upaya yang wajar untuk memastikan bahwa semua penyedia layanan pihak ketiga tersebut memberikan tingkat perlindungan yang sebanding dengan komitmen kami berdasarkan Kebijakan Privasi ini.
      </p>

      <p align="justify">
        ii.&nbsp; Sejauh diperbolehkan oleh hukum dan peraturan perundang-undangan yang berlaku di Indonesia, Informasi Pribadi Anda juga dapat disimpan atau diproses di luar negara Anda oleh pihak yang bekerja untuk Kami di negara lain, atau oleh penyedia layanan pihak ketiga, vendor, pemasok, mitra, kontraktor, atau Afiliasi Kami. Dalam hal tersebut, Kami akan memastikan bahwa Informasi Pribadi tersebut tetap menjadi subjek dari tingkat perlindungan yang sebanding dengan apa yang disyaratkan dalam hukum negara Anda (dan, dalam hal apapun, sejalan dengan komitmen Kami dalam Kebijakan Privasi ini).
      </p>
    </div>
    <br />

    <p align="justify">
      <strong>7. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Keamanan Informasi Pribadi Anda</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        i.&nbsp;
        Kerahasiaan data dan Informasi Pribadi Anda adalah hal yang terpenting bagi Kami. Kami akan memberlakukan upaya dan
        langkah terbaik dan wajar (termasuk namun tidak terbatas menerapkan metode
        &nbsp;
        <em>
          cryptography
        </em>
        ,
        &nbsp;
        <em>
          encryption
        </em>
        , dan/atau metode
        lainnya) untuk melindungi dan mengamankan Informasi Pribadi Anda, serta untuk mencegah akses atau pengungkapan Informasi
        Pribadi yang tidak sah atau bertentangan dengan hukum yang berlaku. Akan tetapi, Kami tidak dapat sepenuhnya menjamin
        bahwa sistem Kami tidak akan dapat ditembus sama sekali akibat adanya virus,
        {' '}
        <em>malware</em>
        ,
        gangguan atau kejadian luar biasa
        termasuk akses tanpa otorisasi oleh pihak ketiga.
      </p>

      <p align="justify">
        ii.&nbsp;
        Anda mengakui bahwa Kami tidak dapat menjamin keutuhan dan keakuratan Informasi Pribadi apapun yang Anda kirimkan
        melalui internet, atau menjamin bahwa Informasi Pribadi tersebut tidak akan dicegat, diakses, digunakan,
        diungkapkan,
        diubah atau dihancurkan oleh pihak ketiga yang tidak berwenang, secara tidak sah atau bertentangan dengan Kebijakan
        Privasi ini dan/atau Hukum yang Berlaku (“
        <strong>Pelanggaran Keamanan</strong>
        ”),
        karena faktor-faktor di luar kendali Kami. Kami akan
        segera mengambil tindakan yang wajar, untuk mencegah, menyelidiki, menghentikan, memperbaiki Pelanggaran Keamanan,
        dan/atau memitigasi konsekuensi dari Pelanggaran Keamanan dan dapat memberitahukan Anda mengenai Pelanggaran
        Keamanan.
      </p>

      <p align="justify">
        iii.&nbsp;
        Anda tidak boleh mengungkapkan sandi akun Anda kepada siapapun dan harus senantiasa menjaga kerahasiaan sandi Anda dan keamanan perangkat yang Anda gunakan.
      </p>
    </div>
    <br />

    <p align="justify">
      <strong>8. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Akses dan Koreksi Informasi Pribadi</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        i.&nbsp; Tunduk pada peraturan perundang-undangan yang berlaku, Anda dapat meminta kepada Kami untuk mengakses dan/atau mengoreksi Informasi Pribadi Anda yang berada dalam kepemilikan dan penguasaan Kami, dengan menghubungi Kami di rincian kontak disebutkan pada poin terakhir Kebijakan Privasi ini atau yang kami informasikan dari waktu ke waktu pada Platform atau Situs Web.
      </p>

      <p align="justify">
        ii.&nbsp; Kami berhak menolak permintaan Anda untuk mengakses, atau untuk memperbaiki, sebagian atau semua Informasi Pribadi Anda yang Kami miliki atau kuasai jika diizinkan atau diperlukan berdasarkan perundang-undangan yang berlaku. Hal ini termasuk dalam keadaan di mana Informasi Pribadi tersebut dapat berisi referensi kepada orang lain atau di mana permintaan untuk akses atau permintaan untuk mengoreksi adalah untuk alasan yang Kami anggap tidak relevan, tidak serius, atau menyulitkan.
      </p>
    </div>
    <br />

    <p align="justify">
      <strong>9. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Penarikan Persetujuan Anda</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        i.&nbsp; Kecuali ditentukan lain oleh peraturan perundang-undangan, Anda dapat melakukan penarikan persetujuan Anda atas pengumpulan, penggunaan dan/atau pengungkapan Informasi Pribadi Anda dan/atau pemusnahan Informasi Pribadi Anda yang persyaratan dan tata caranya sesuai dengan peraturan perundang-undangan yang secara khusus mengatur hal ini, dengan memberikan pemberitahuan tertulis kepada Kami dari waktu ke waktu melalui Platform atau Situs Web.
      </p>

      <p align="justify">
        ii.&nbsp; Penarikan persetujuan atau pemusnahan Informasi Pribadi Anda baik sebagian atau seluruhnya, dapat mengakibatkan Anda tidak lagi dapat menggunakan Layanan dan Platform. Dengan ini Anda menyatakan telah mengetahui, mengerti, memahami dan menyetujui dampak penarikan persetujuan dan/atau pemusnahan Informasi Pribadi Anda tersebut.
      </p>
    </div>
    <br />

    <p>
      <strong>10. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Perubahan Terhadap Kebijakan Privasi Kami</strong>
    </p>
    <p align="justify" className="ml-5 mt-4">
      Kami dapat mengubah Kebijakan Privasi ini dari waktu ke waktu untuk mencerminkan perubahan dalam kegiatan Kami. Jika Kami mengubah Kebijakan Privasi ini, Kami akan memberitahu Anda tentang perubahan tersebut melalui pemberitahuan umum yang dipublikasikan pada Situs Web, Platform, atau ke alamat e-mail Anda. Kami menghimbau Anda untuk meninjau halaman ini secara berkala untuk mengetahui informasi terbaru tentang bagaimana ketentuan Kebijakan Privasi ini Kami berlakukan. Anda mengerti, memahami dan mengakui bahwa dengan tetap mengakses Situs Web kami dan terus menggunakan Layanan Kami setelah adanya perubahan apapun terhadap Kebijakan Privasi ini, hal tersebut akan dianggap sebagai persetujuan Anda terhadap Kebijakan Privasi ini dan segala perubahannya.
    </p>
    <br />

    <p>
      <strong>11. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Anak di Bawah Umur</strong>
    </p>

    <p align="justify" className="ml-5 mt-4">
      Kami mungkin tidak dapat membedakan usia orang yang mengakses dan menggunakan Platform dan/atau Situs Web. Jika seorang anak di bawah umur (menurut hukum yang berlaku) telah memberikan Informasi Pribadinya kepada Kami tanpa persetujuan orang tua atau walinya, orang tua atau walinya itu harus menghubungi Kami untuk menghapus Informasi Pribadi yang terkait dan menghapus nama anak di bawah umur tersebut. Apabila Kami tidak dihubungi oleh orang tua atau walinya, maka apabila dipandang perlu Kami atas diskresi sendiri dapat menghapus nama anak di bawah umur tersebut. Apabila telah tercipta hak dan kewajiban atas hubungan hukum yang ada, maka wali atau orang tua berhak dan/atau berkewajiban untuk memenuhinya.
    </p>
    <br />

    <p>
      <strong>12. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Materi Pemasaran</strong>
    </p>

    <p align="justify" className="ml-5 mt-4">
      Kami dapat mengirimkan Anda Materi Pemasaran melalui pesan singkat
      (
      <em>short message service &ndash; SMS, &nbsp;</em>
      e-mail
      <em>, &nbsp;</em>
      <em>Chat Platform &nbsp;</em>
      dan
      <em>&nbsp;</em>
      Media Sosial &nbsp;jika Anda telah setuju untuk berlangganan milis Kami, dan/atau setuju untuk menerima materi pemasaran dan promosi dari Kami. Anda dapat memilih untuk tidak menerima komunikasi pemasaran tersebut kapan saja dengan mengklik pilihan &ldquo;berhenti berlangganan&rdquo; yang ada dalam pesan yang bersangkutan, atau menghubungi kami melalui detail kontak yang tercantum di bawah ini. Mohon perhatikan bahwa jika anda memilih untuk keluar, kami masih dapat mengirimi Anda pesan-pesan non-promosi, seperti informasi tentang Akun Anda.
    </p>
    <br />

    <p>
      <strong>13. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Platform Pihak Ketiga</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        i.&nbsp; Situs Web, dan Materi Pemasaran dapat berisi tautan ke situs web yang dioperasikan oleh pihak ketiga. Kami tidak mengendalikan atau menerima pertanggungjawaban atau tanggung jawab untuk situs web ini dan untuk pengumpulan, penggunaan, pemeliharaan, berbagi, atau pengungkasan data dan informasi oleh pihak ketiga tersebut. Silakan baca syarat dan ketentuan dan kebijakan privasi dari situs web pihak ketiga tersebut untuk mengetahui bagaimana mereka mengumpulkan dan menggunakan Informasi Pribadi Anda.
      </p>

      <p align="justify">
        ii.&nbsp; Iklan yang terdapat pada Situs Web, dan Materi Pemasaran kami berfungsi sebagai tautan ke situs web pengiklan dan dengan demikian segala informasi yang mereka kumpulkan berdasarkan klik Anda pada tautan itu akan dikumpulkan dan digunakan oleh pengiklan yang relevan sesuai dengan kebijakan privasi pengiklan tersebut.
      </p>

      <p align="justify">
        iii.&nbsp; Kami tidak bertanggung jawab atas keakuratan informasi, konten, produk atau layanan yang disediakan atau ditawarkan oleh pihak ketiga atau diadopsi oleh situs-situs web pihak ketiga. Anda telah memahami, mengerti, mengakui dan menyetujui bahwa Anda membebaskan Kami dari setiap tuntutan, klaim, tanggung jawab atau kewajiban atas ketersediaan, keakuratan, kesesuaian, kelengkapan atau kebenaran layanan, konten, informasi atau produk yang disediakan atau ditawarkan oleh pihak ketiga tersebut. Kami tidak membuat representasi atau jaminan apa pun tentang layanan, konten, informasi dan/atau produk yang disediakan oleh pihak ketiga.
      </p>

      <p align="justify">
        iv.&nbsp; Anda dapat menghubungi pihak ketiga tersebut secara langsung jika memiliki masalah atau apabila memiliki pertanyaan terkait dengan situs web, layanan, konten, informasi atau produk yang disediakan atau ditawarkan oleh pihak ketiga tersebut.
      </p>
    </div>
    <br />

    <p>
      <strong>14. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Penerapan Anti Pencucian Uang dan Pencegahan Pendanaan Terorisme</strong>
    </p>

    <p align="justify" className="ml-5 mt-4">
      Anda menyetujui bahwa Kami dapat setiap saat meminta dokumen pendukung tambahan atau Informasi Pribadi Anda yang relevan untuk kebutuhan pemrosesan Layanan dan/atau kebutuhan penerapan anti pencucian uang dan pencegahan pendanaan terorisme.
    </p>
    <br />

    <p>
      <strong>15. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pembatasan Tanggung Jawab</strong>
    </p>
    <p align="justify" className="ml-5 mt-4">
      Anda dengan ini membebaskan dan/atau melepaskan Kami atau Afiliasi Kami dari segala tuntutan, klaim dan/atau gugatan yang timbul sehubungan dengan, namun tidak terbatas pada: (i) pemberian akses, perolehan, pengumpulan, pengolahan, penggunaan, analisis, pendistribusian, pengungkapan, penampilan, dan pengiriman &nbsp;Informasi Pribadi Anda sebagaimana diatur dalam Kebijakan Privasi ini atau untuk hal lainnya yang telah mendapatkan persetujuan Anda dari waktu ke waktu, (ii) informasi tidak tepat dan tidak akurat yang Anda berikan kepada Kami atau Afiliasi Kami, (iii) tidak dilakukannya pengkinian data
      (
      <em>update</em>
      ) atas perubahan data atau Informasi Pribadi Anda yang digunakan untuk pendaftaran Layanan, dan/atau (iv) apabila Anda memberikan sandi kepada pihak ketiga.
    </p>
    <br />

    <p>
      <strong>16. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hukum yang Mengatur dan Bahasa</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        i.&nbsp; Kebijakan Privasi ini diatur oleh dan ditafsirkan menurut hukum Negara Republik Indonesia. Setiap dan seluruh sengketa yang timbul dari Kebijakan Privasi ini akan diatur oleh yurisdiksi eksklusif dari Pengadilan Negeri Jakarta Selatan.
      </p>

      <p align="justify">
        ii.&nbsp; Kebijakan Privasi ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris. Apabila terdapat ketidaksesuaian antara versi Bahasa Indonesia dan versi Bahasa Inggris, maka versi Bahasa Indonesia yang akan berlaku.
      </p>
    </div>
    <br />

    <p>
      <strong>17. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Definisi</strong>
    </p>
    <div className="ml-5 mt-4 flex flex-col gap-3">
      <p align="justify">
        &ldquo;
        <strong>Afiliasi</strong>
        &rdquo; berarti (i) pihak pengendali dari; (ii) anak perusahaan dari; atau (iii) pihak yang berada dalam satu pengendalian dengan; atau (iv) pihak yang berada dalam satu grup usaha dengan Kami.
      </p>

      <p align="justify">
        &ldquo;
        <strong>Anda</strong>
        &rdquo; berarti setiap pihak yang menggunakan Layanan dan/atau mengunjungi atau mengakses Platform.
      </p>

      <p align="justify">
        &quot;
        <strong>Informasi Pribadi</strong>
        &quot; berarti informasi dan data mengenai Anda yang secara pribadi dapat diidentifikasi, yang Anda berikan atau dikumpulkan melalui Platform dan/atau Layanan, termasuk, namun tidak terbatas pada nama, alamat, tanggal lahir, kartu identitas penduduk, dan pekerjaan (apabila Anda adalah seorang individu), data dan dokumen identitas perusahaan (apabila Anda bukan seorang individu), nomor telepon, alamat surat elektronik (
        <em>e-mail</em>
        ), perizinan dan/atau sejenisnya, dan informasi lain dan juga catatan atas transaksi dan kegiatan Anda dalam menggunakan Layanan yang mungkin dapat mengidentifikasi Anda.
      </p>

      <p align="justify">
        &quot;
        <strong>Kami</strong>
        &quot; berarti PT Mapan Global Reksa, suatu perusahaan yang didirikan berdasarkan hukum Negara Republik Indonesia, sebagai penyelenggara pinjam meminjam uang berbasis teknologi informasi yang terdaftar pada Otoritas Jasa Keuangan, dan/atau Afiliasinya.
      </p>

      <p align="justify">
        &quot;
        <strong>Layanan</strong>
        &quot; berarti berbagai layanan yang ditawarkan Kami sebagai penyelenggara pinjam meminjam uang berbasis teknologi informasi.
      </p>

      <p align="justify">
        &ldquo;
        <strong>Materi Pemasaran</strong>
        &rdquo; berarti pemasaran langsung, iklan, dan komunikasi promosi melalui pos, panggilan telepon, layanan pesan singkat (SMS), dan email.
      </p>

      <p align="justify">
        &ldquo;
        <strong>Pemberi Pinjaman</strong>
        &rdquo; berarti pihak yang menyediakan dana pinjaman kepada Anda melalui Kami.
      </p>

      <p align="justify">
        &ldquo;
        <strong>Pihak yang Disetujui</strong>
        &rdquo; berarti pihak-pihak yang diberikan persetujuan oleh Anda untuk memberikan Informasi Pribadi Anda, yang berada dalam penguasaan pihak tersebut, kepada Kami dalam rangka penerimaan Layanan.
      </p>

      <p align="justify">
        &ldquo;
        <strong>Platform</strong>
        &rdquo; berarti sarana elektronik yang Kami gunakan untuk memberikan informasi dan Layanan kepada Anda termasuk namun tidak terbatas pada Situs Web dan/atau aplikasi yang dibuat dan dikelola oleh Kami serta aplikasi dan situs web yang dikelola oleh pihak ketiga.
      </p>

      <p align="justify">
        &quot;
        <strong>Situs Web</strong>
        &quot; berarti situs web yang Kami gunakan yaitu&nbsp;
        <a href="https://mab.co.id">mab.co.id</a>
&nbsp;
        dan/atau situs lainnya yang secara resmi Kami kembangkan guna mendukung ekosistem Layanan.
      </p>

      <p align="justify">
        &ldquo;
        <strong>Tujuan Pengembangan Layanan</strong>
        &rdquo; berarti tujuan penggunaan dan pengungkapan Informasi Pribadi untuk tujuan, termasuk namun tidak terbatas pada:
      </p>
      <div className="ml-5 flex flex-col gap-3">
        <p align="justify">
          a.&nbsp; menilai atau memahami efektivitas promosi marketing Kami pada Platform dan untuk menyampaikan iklan yang relevan kepada Anda; &nbsp;
        </p>

        <p align="justify">
          b.&nbsp; membuat saran dan rekomendasi untuk Anda tentang Layanan atau produk dan layanan pihak ketiga yang mungkin menarik bagi Anda;
        </p>

        <p align="justify">
          c.&nbsp; menjaga akurasi informasi &rdquo;
          <em>know your customer</em>
          &rdquo; dan melakukan pemeriksaan, sehubungan dengan kebijakan anti pencucian uang dan pendanaan terorisme, kredit dan latar belakang Anda;
        </p>

        <p align="justify">
          d.&nbsp; untuk memelihara, mengembangkan, menguji, meningkatkan, dan mempersonalisasikan Layanan untuk memenuhi kebutuhan dan preferensi Anda;
        </p>

        <p align="justify">
          e.&nbsp; untuk mencegah, mendeteksi dan menyelidiki segala kegiatan yang dilarang, ilegal, tidak sah, atau curang;
        </p>

        <p align="justify">
          f.&nbsp; melakukan kegiatan-kegiatan yang berkaitan dengan penyediaan Layanan yang ditawarkan atau yang dikeluarkan oleh Kami atau pihak ketiga yang bekerjasama dengan Kami dan penyediaan laporan penelitian atau bahan untuk analisis;
        </p>

        <p align="justify">
          g.&nbsp; melakukan penilaian risiko, analisis dan perencanaan statistik dan tren, termasuk melaksanakan pengolahan data, analisis statistik, kredit, manajemen risiko dan anti pencucian uang, membuat dan mengelola model penilaian kredit, melakukan pemeriksaan dan peninjauan kredit dan latar belakang lain, dan menyimpan sejarah kredit Anda dan Individu yang Relevan untuk referensi saat ini dan di masa mendatang baik untuk kepentingan Layanan yang disediakan Kami ataupun layanan yang diberikan oleh pihak ketiga lainnya;
        </p>

        <p align="justify">
          h.&nbsp; memantau dan mencatat panggilan dan komunikasi elektronik dengan Anda untuk tujuan pencatatan, kualitas, pelatihan, investigasi, dan pencegahan penipuan;
        </p>

        <p align="justify">
          i.&nbsp; melaksanakan (termasuk, namun tidak terbatas pada, penagihan jumlah yang terutang kepada Anda berdasarkan Layanan yang diambil) atau membela hak-hak Kami dan Pemberi Pinjaman, yang berasal dari kontrak atau dokumen lainnya;
        </p>

        <p align="justify">
          j.&nbsp; melakukan manajemen internal untuk mengoperasikan sistem informasi kontrol dan manajemen dan melaksanakan audit internal atau mengizinkan pelaksanaan audit eksternal;
        </p>

        <p align="justify">
          k.&nbsp; memungkinkan pihak ketiga yang menerima hak Kami dan/atau Pemberi Pinjaman terhadap Anda, untuk mengevaluasi transaksi yang dimaksudkan untuk menjadi obyek dari pengalihan;
        </p>

        <p align="justify">
          l.&nbsp; untuk memasarkan produk atau layanan keuangan atau layanan lain yang terkait dengan pinjaman melalui berbagai moda komunikasi dan merancang atau menyaring produk atau layanan yang serupa termasuk dengan melakukan riset pasar, analisis data, dan survei; dan/atau
        </p>

        <p align="justify">
          m.&nbsp; untuk memungkinkan kami mematuhi semua kewajiban berdasarkan peraturan perundang-undangan yang berlaku, (namun tidak terbatas pada menanggapi permintaan, penyelidikan, atau arahan peraturan) dan melakukan pemeriksaan audit, uji tuntas dan penyelidikan. &nbsp;
        </p>
      </div>
    </div>
    <br />

    <p>
      <strong>18. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Kontak</strong>
    </p>

    <p align="justify" className="ml-5 mt-4">
      Jika Anda memiliki pertanyaan lebih lanjut tentang privasi dan keamanan informasi Anda dan ingin memperbarui atau menghapus data Anda, maka silakan hubungi kami di&nbsp;
      <a href="mailto:support@mab.co.id">
        <u>support@mab.co.id</u>
      </a>
      &nbsp;atau saluran komunikasi lainnya sebagaimana Kami informasikan dari waktu ke waktu pada Platform.
    </p>
  </div>
);

export default PrivacyPolicyId;
